const API_BASE_URL = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? ''
const FUNCTIONS_BASE = `${API_BASE_URL}/.netlify/functions`

const request = async (path, options = {}) => {
  const url = `${FUNCTIONS_BASE}${path}`
  const { token, headers: extraHeaders, ...rest } = options
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...(extraHeaders || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...rest,
  })

  if (!response.ok) {
    const text = await response.text()
    throw new Error(text || `Request failed (${response.status})`)
  }

  const payload = await response.json().catch(() => ({}))
  return payload.data ?? payload
}

export const saveProfile = (data, { token } = {}) =>
  request('/profile', {
    method: 'POST',
    body: JSON.stringify(data),
    token,
  })

export const fetchProfile = (userSub, { token } = {}) =>
  request(`/profile?userSub=${encodeURIComponent(userSub)}`, { token })
